// ~/composables/useBuyNow.ts
import { useCartStore } from '~/store/cartStore';
import { useUserStore } from '~/store/userStore';
import { useUIStore } from '~/store/uiStore';
import { watch, computed, ref, ComputedRef } from 'vue';
import { ModalTypes } from '@/types/enums';
import { UserData, BuyNowProduct } from '@/types/index';

const LOGIN_MODAL_MESSAGE = "Please login or sign up to continue.";

export default function useBuyNow() {
    const userStore = useUserStore();
    const uiStore = useUIStore();
    const cartStore = useCartStore();
    
    const initiatedBuyNow = ref(false);
    const isLoggedIn: ComputedRef<boolean> = computed(() => userStore.userData?.is_logged_in || false);
    const pendingProducts = ref(null);

    const reset = () => {
        initiatedBuyNow.value = false;
        pendingProducts.value = null;
    };

    watch(
        () => userStore.userData,
        (newUserData: UserData) => {
            if (initiatedBuyNow.value && newUserData?.is_logged_in && pendingProducts.value) {
                //uiStore.setPopupMessage("Quick checkout.", pendingProducts.value);
                //cartStore.buyNow(pendingProducts.value);
                reset();
            }
        },
        { deep: true }
    );

    const buyNow = (products: BuyNowProduct[]) => {
        console.log("Buying now:", products);
        if (isLoggedIn.value) {
            uiStore.setPopupMessage("Quick checkout.", products.value);
            cartStore.buyNow(products);
        } else {
            pendingProducts.value = products;
            initiatedBuyNow.value = true;
            uiStore.setModalType(ModalTypes.LOGIN, LOGIN_MODAL_MESSAGE);
        }
    };

    const buyNowSingle = (product: string) => {
        buyNow([{ name: product, quantity: 1 }]);
    }

    return {
        buyNow,
        buyNowSingle,
        reset
    };
}
